export default __webpack_public_path__ + "img/f0ae4fe396c930740d28aabf0946f8b0.png";